<template>
  <div class="d-flex">
    <v-checkbox
      on-icon="$CheckedBox"
      off-icon="$UncheckedBox"
      hide-details
      v-bind="$attrs"
      v-on="$listeners"
      :ripple="false"
      color="brand-secondary tone-400"
      class="mt-0 align-start"
    >
      <template #label>
        <span class="neutral--text text-body-s ml-md-2 text--tone-400">
          {{ label }}
        </span>
      </template>
    </v-checkbox>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'BaseCheckbox',
  props: {
    label: {
      type: String,
      required: true,
    },
  },
});
</script>

<style lang="scss">
.v-input--checkbox .v-input__control .v-input__slot {
  align-items: center !important;
}
</style>
